import React, { useEffect, useState } from 'react';
import styles from './NoveltyNotification.module.css';

const NoveltyNotification: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 800);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.notification} role="status">
      <button className={styles.close} onClick={dismiss} aria-label="Fermer">
        ✕
      </button>
      <span className={styles.badge}>Nouveauté</span>
      <p className={styles.title}>Certification obtenue</p>
      <p className={styles.text}>
        Conduire et piloter un projet innovant avec des méthodes agiles
      </p>
      <p className={styles.meta}>Certification RS6099 · ORIIONS</p>
      <a
        href="https://parchment.procertif.com/019f4cb8-c5fc-73f1-aa9f-765122e7a9a4.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
        onClick={dismiss}
      >
        Voir le certificat →
      </a>
    </div>
  );
};

export default NoveltyNotification;
